import {decorateLinkBox} from "../timeline/linkBox/decorateLinkBox.js";
import {decorateSocialMediaBox} from "../timeline/socialMediaBox/decorateSocialMediaBox.js";
import {decorateImagesBox} from "../timeline/imagesBox/decorateImagesBox.js";
import {decorateItemBox} from "../timeline/itemBox/decorateItemBox.js";
export function handleData(data, timelineEntry) {
    var parsed = $.parseJSON(data);
    switch (parsed.type) {
        case "1":
            decorateLinkBox(parsed, "link", timelineEntry);
            break;
        case "3":
            decorateSocialMediaBox(parsed, "social_media", timelineEntry);
            break;
        case "4":
            decorateImagesBox(parsed, "images", timelineEntry);
            break;
        case "5":
            decorateItemBox(parsed, "item", timelineEntry);
            break;
    }
}